import { Dropdown, Menu } from "antd";
import { useHistory, withRouter } from "react-router";
import { GlobalOutlined } from "@ant-design/icons";
import { useEffect } from "react";

function LanguageSwitcher({
  supportedLanguages,
  currentLanguage,
  setCurrentLanguage,
}) {
  const history = useHistory();
  const menu = (
    <Menu>
      {supportedLanguages.map((language) => (
        <Menu.Item
          key={language.value}
          onClick={() => {
            const url = history.location.pathname.split("/");
            url[1] = language.value;
            const formattedURL = url.toString().replaceAll(",", "/");
            history.push(formattedURL);
            setCurrentLanguage(language);
          }}
        >
          {language.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    const initialLang = supportedLanguages.find(
      (lang) => lang.value === history.location.pathname.split("/")[1]
    );
    setCurrentLanguage(initialLang);
  }, []);
  return (
    <Dropdown overlay={menu} placement="bottomLeft" arrow trigger={["click"]}>
      <span className="languageSwitcher">
        <GlobalOutlined className="languageIcon" title="change language" />
        <span style={{ fontSize: "20px", padding: "5px" }}>
          {currentLanguage.value}
        </span>
      </span>
    </Dropdown>
  );
}

export default withRouter(LanguageSwitcher);
